export default __webpack_public_path__ + "static/media/carouselMob.5f708163.png";